import store from '@/store/index.js';
import ImageCompressor from 'image-compressor.js'
import {
    imageFileUpload,
    uploadFileBase,
    removeImg
} from '@/api/myCar'

let imgPatch = store.state.user.imgPatch;
let imgFiles = []; // 图片原文件
// let imgs = []; // 图片预览地址
let imgFilesUrl = []; // 上传成功后回调的图片路径
let imgFilesUrlOrg = []; // 上传成功后回调的图片路径
function fileChange (type) {
    // 加入图片
    var event = event || window.event;
    var file = event.target.files;
    var leng = file.length;
    // var img = e.target.result;
    for (var i = 0; i < leng; i++) {
        imgFiles.push(file[i]);
        // alert(file[i].size)
        compressImage(file[i]).then(res=> {
            // alert(res.size)
            var reader = new FileReader(); // 使用 FileReader 来获取图片路径及预览效果
            reader.readAsDataURL(res);
            reader.onload = function (e) {
                fileUp(e.target.result, type)
                // imgs.push(e.target.result); // base 64 图片地址形成预览
            };
        })
    }
    // console.log(imgFilesUrl)
    // console.log(imgFilesUrlOrg)
}
function compressImage(file) {
    return new Promise((resolve, reject) => {
        new ImageCompressor(file, {
            quality: 0.4,
            checkOrientation: false,
            success(result) {
                resolve(result);
            },
            error(e) {
                reject();
            }
        });
    });
}
function del (i) {
    // console.log(i);
    fileDel(i);
}

function fileUp (data, type) {
    // type : 1、身份证；2、电动车、3：线索
    uploadFileBase({
        file: data,
        type: type
    }).then(res => {
        if (res.code == '0') {
            imgFilesUrlOrg.push(res.data)
            // 'http://localhost:8091/ev-wechat/file?fileName='
            let a = {
                src: imgPatch + res.data.src,
                msrc: imgPatch + res.data.msrc,
            }
            imgFilesUrl.push(a)

            console.log(imgFilesUrl)
            console.log(imgFilesUrlOrg)

        } else {
            this.$vux.toast.text(res.desc, 'center')
        }
    });
}
function fileDel (i) {
    // console.log(imgFilesUrl[i])
    // console.log(imgFilesUrl[i].msrc)
    removeImg({
        fileName: imgFilesUrl[i].msrc
    }).then(res => {
        if (res.code == '0') {
            // 根据下标删除
            imgFiles.splice(i, 1);
            // imgs.splice(i, 1);
            imgFilesUrl.splice(i, 1);
            imgFilesUrlOrg.splice(i, 1);
        } else {
            this.$vux.toast.text(res.desc, 'top')
        }
    });
}
function clear () {
    imgFiles.splice(0, imgFiles.length );
    imgFilesUrl.splice(0, imgFilesUrl.length);
    imgFilesUrlOrg.splice(0, imgFilesUrlOrg.length);
    console.log('0', imgFilesUrl)
    console.log('0', imgFilesUrlOrg)

}

function potArry (data1, data2) {
    imgFilesUrl = data1;
    imgFilesUrlOrg = data2;
}


export default {
    imgFilesUrl,
    imgFilesUrlOrg,
    // imgFiles,
    // imgs,
    fileChange,
    del,
    clear,
    potArry
}



// WEBPACK FOOTER //
// ./src/assets/js/upload2.js